const hasText = (value: string | null | undefined): value is string => {
  return value != null && value.trim() !== "";
};

export const pickLocalizedText = (
  translated: string | null | undefined,
  origin: string | null | undefined
): string | null => {
  if (hasText(translated)) {
    return translated;
  }

  if (hasText(origin)) {
    return origin;
  }

  return null;
};
